import { isContainerType } from '../core/registry.js';

/**
 * Return true if the given block id can have children dropped into it directly
 * during a drag operation (i.e., it is a container and the dragged block is
 * allowed inside it).
 *
 * @param {string} blockType       – type of the block being dragged
 * @param {string} targetBlockType – type of the block being hovered over
 * @returns {boolean}
 */
export function canNestInto(blockType, targetBlockType) {
  if (!isContainerType(targetBlockType)) return false;
  // columns block is a special case: only accepts 'column' children
  if (targetBlockType === 'columns' && blockType !== 'column') return false;
  if (targetBlockType === 'column' && blockType === 'column') return false;
  if (targetBlockType === 'column' && blockType === 'columns') return false;
  return true;
}

/**
 * Container types that can be dropped into root directly by the user.
 */
export const ROOT_CONTAINER_TYPES = ['group', 'columns'];

/**
 * Types that are only valid as children of a specific parent.
 * If present in this map the block cannot be inserted at root level via the
 * Inserter.
 */
export const RESTRICTED_PARENTS = {
  column: 'columns',
};
